// Preserve only provider fields saved after this request began. The response
// still owns page membership, other fields, and every unrelated row. Keep the
// latest save per record until logout: an older request may still be in flight
// after a newer one completes, so completing a request cannot retire the saves.
export default function mergeProviderSaves(rows, saves, requestRevision) {
  if (requestRevision === undefined || !Array.isArray(rows)) return rows;

  return rows.map((row) => {
    const saved = saves[row.file_token];
    if (!saved || saved.revision <= requestRevision) return row;

    return {
      ...row,
      referred_to_provider: saved.referred_to_provider,
      referred_to_provider_history: saved.referred_to_provider_history,
    };
  });
}
